<template>
  <div class="common-box">
    <el-row class="row-one">
      <span class="row-one-title">积分记录</span>
      <Reback class="row-one-fr" @click.native="$router.go(-1)"></Reback>
    </el-row>
    <el-form class="form-single-inline margin-t20" :inline="true" :model="pointsRecordForm">
      <el-form-item label="我的积分:">
        <span class="aColor margin-l10">{{pointsCount}}</span>
      </el-form-item>
      <br>
      <el-form-item label="使用状态：">
        <el-radio-group v-model="pointsRecordForm.type" class="radio-single-btn1">
          <el-radio-button label="0">不限</el-radio-button>
          <el-radio-button label="1">获得积分</el-radio-button>
          <el-radio-button label="2">使用积分</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="search" @click="search">查询 <i class="el-icon-search"></i></el-button>
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <el-table v-loading="loading" element-loading-text="加载中..." :data="pintsRecord" class="table-single margin-t20" stripe>
      <el-table-column label="时间" prop="date">
        <template slot-scope="scope">{{scope.row.date.split(' ')[0]}}</template>
      </el-table-column>
      <el-table-column label="积分增减" prop="pointchg"></el-table-column>
      <el-table-column label="说明" prop="sname"></el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination class="pagination-single" @current-change="handleCurrentChange" :current-page.sync="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="total" hide-on-single-page>
    </el-pagination>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  data () {
    return {
      pointsCount: '--',
      pointsRecordForm: {
        type: '0'
      },
      pintsRecord: [],
      pageNum: 1,
      pageSize: 20,
      total: 20,
      loading: true,
    }
  },
  mounted () {
    this.getPointsRecord()
  },
  methods: {
    handleCurrentChange (page) {
      this.pageNum = page
      this.loading = true
      this.getPointsRecord()
    },
    // 积分记录
    getPointsRecord () {
      this.$http.post(this.$apiPath.getIntegralWithPage, {
        identify: Base64.decode(this.$commonJs.getCookie('u_id')),
        type: this.pointsRecordForm.type,
        pageNo: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        this.loading = false
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data
        this.total = result.totalNum
        if (result.pointDetail.length > 0) {
          this.pointsCount = this.pageNum == 1 && this.pointsRecordForm.type == '0' ? result.pointDetail[0].currpoint : this.pointsCount
        } else {
          this.pointsCount = 0
        }
        this.pintsRecord = result.pointDetail
      }).catch(err => { })
    },
    search () {
      this.loading = true
      this.getPointsRecord()
    }
  }
}
</script>

